import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import ServiceProgramList from '../../containers/service-program/ServiceProgramList'
import ServiceProgramAddModal from '../../containers/service-program/ServiceProgramAddModal'
import ServiceProgramEditModal from '../../containers/service-program/ServiceProgramEditModal'
import ServiceProgramRemoveModal from '../../containers/service-program/ServiceProgramRemoveModal'
import BackToList from '../ui/BackToList'

export default class ServiceProgramPane extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={ServiceProgramAddModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={ServiceProgramRemoveModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={ServiceProgramEditModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Service Program</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/service-program/create'
            >
              <Plus className='svg-white mr1' />
              Add Service Program
            </Link>
          </div>
          <hr />

          <ServiceProgramList baseUrl={this.props.match.path} />
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/ServiceProgramPane.tsx